import { useState } from 'react';
import { Fields } from '@measured/puck';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import QuilHelper from './quilHelper';
export type QuillTextEditorProps = {
  content: string;
};

export const QuillTextEditor = (
  type: string,
  enableLink = true,
  id?: number,
): Fields<QuillTextEditorProps> => {
  return {
    content: {
      type: 'custom',
      render: ({ value, onChange }) => {
        const [isOpen, setIsOpen] = useState(false);
        return (
          <>
            <div
              className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
              onClick={() => setIsOpen(!isOpen)}>
              <h3>{type}</h3>
              {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
            </div>
            {isOpen && (
              <QuilHelper
                value={value}
                onChange={onChange}
                enableLink={enableLink}
                id={id}
              />
            )}
          </>
        );
      },
    },
  };
};
